import IPalette from "./palette";

export default class Color {
    color: string;
    base: number;
    palette: IPalette;

    constructor(q: number, palette: IPalette){
        this.palette = palette;
        if(q === 8)
            q=7;
        else
            if(q === 7)
                q=8;
        this.base = q;
    }

    shade(n: number): string {
        // console.log("SHADE", this.base, n);
        let pal = this.palette.values[this.base];
        // return `rgba(${pal.r},${pal.g},${pal.b},${pal.a}`;

        let R = Math.round(pal.r * (n*20) / 100);
        let G = Math.round(pal.g * (n*20) / 100);
        let B = Math.round(pal.b * (n*20) / 100);

        R = (R<255)?R:255;  
        G = (G<255)?G:255;  
        B = (B<255)?B:255;  

        return `rgba(${R},${G},${B},255)`;
    }
}